import Button from "../../components/Button";
import styles from "./menuLink.module.css";
import { Link } from "react-router-dom";
import useIsMobile from "../../hooks/useIsMobile";

const MenuLink = ({
  children,
  caption,
  to,
  onDropdownClick,
  isOpen = false,
  counter = 0,
}) => {
  const isMobile = useIsMobile();
  if (isMobile === true) return null;

  return (
    <div className={styles.menuLinkContainer}>
      <div className={styles.menuLinkHeader}>
        <h4 style={{ margin: "0", position: "relative" }}>
          {to != null ? (
            <Link to={to} className={styles.menuLink}>
              {caption}
            </Link>
          ) : (
            caption
          )}
          {counter > 0 ? (
            <div className={styles.menuLinkCounter}>{counter}</div>
          ) : null}
        </h4>
        <div className={styles.spacer} />
        {typeof onDropdownClick === "function" ? (
          <Button
            inline
            icon={isOpen ? "chevronUp" : "chevronDown"}
            onClick={onDropdownClick}
          />
        ) : null}
      </div>
      {isOpen ? <div className={styles.menuLinkSubmenu}>{children}</div> : null}
    </div>
  );
};

export default MenuLink;
